// extracted by mini-css-extract-plugin
export default {"root":"Search_root__eiX89","input":"Search_input__klILD","clearIcon":"Search_clearIcon__eIw10"};